import React, { Component } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { SketchPicker } from "react-color";
import addColourImg from "src/img/addColour.png";

const ColorPop = styled.div`
    position: fixed;
    z-index: 1001;
`;

const ColorCover = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
`;

const ColorPickerPanel = styled.div`
    position: relative;
    z-index: 1001;
`;

export const ColorCircle = styled.span`
    width: ${p => p.width || "105px"};
    height: ${p => p.height || "105px"};
    display: inline-block;
    border-radius: 50%;
    background-color: ${ p => p.color};
    background-image: ${p => !p.isPreview ? `url(${addColourImg})` : "none"};
    background-size: 21px;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid #D8DEEC;
    cursor: pointer;
`;

class ColorPicker extends Component {
    state = {
        isColorClicked: false,
        untouched: true,
        pickerPosition: { top: 0, left: 0 },
    };

    triggerRef = React.createRef();
    pickerPanelRef = React.createRef();

    componentDidUpdate(previousProps, previousState) {
        if (!previousState.isColorClicked && this.state.isColorClicked) {
            window.addEventListener("resize", this.updatePickerPosition);
            window.addEventListener("scroll", this.updatePickerPosition, true);
            this.updatePickerPosition();
        }

        if (previousState.isColorClicked && !this.state.isColorClicked) {
            window.removeEventListener("resize", this.updatePickerPosition);
            window.removeEventListener("scroll", this.updatePickerPosition, true);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updatePickerPosition);
        window.removeEventListener("scroll", this.updatePickerPosition, true);
    }

    handleClick = () => {
        this.setState({
            isColorClicked: !this.state.isColorClicked,
            untouched: false,
        });
        this.props.setSelectedColour(true);
    };

    handleClose = () => {
        this.setState({ isColorClicked: false });
    };

    handleColorChange = (color) => {
        this.props.handleColorChange(color);
    };

    updatePickerPosition = () => {
        const trigger = this.triggerRef.current;
        const pickerPanel = this.pickerPanelRef.current;

        if (!trigger || !pickerPanel) {
            return;
        }

        const viewportMargin = 12;
        const pickerGap = 8;
        const triggerBounds = trigger.getBoundingClientRect();
        const pickerWidth = pickerPanel.offsetWidth;
        const pickerHeight = pickerPanel.offsetHeight;
        const maxLeft = window.innerWidth - pickerWidth - viewportMargin;
        const belowTop = triggerBounds.bottom + pickerGap;
        const aboveTop = triggerBounds.top - pickerHeight - pickerGap;
        const top = belowTop + pickerHeight <= window.innerHeight - viewportMargin
            ? belowTop
            : Math.max(viewportMargin, aboveTop);
        const left = Math.max(viewportMargin, Math.min(triggerBounds.left, maxLeft));

        this.setState(previousState => {
            if (previousState.pickerPosition.top === top && previousState.pickerPosition.left === left) {
                return null;
            }

            return { pickerPosition: { top, left } };
        });
    };

    renderPickerPopup = (color) => {
        const { pickerPosition } = this.state;

        return createPortal(
            <>
                <ColorCover onClick={this.handleClose} />
                <ColorPop style={pickerPosition}>
                    <ColorPickerPanel ref={this.pickerPanelRef}>
                        <SketchPicker color={color} onChange={this.handleColorChange} />
                    </ColorPickerPanel>
                </ColorPop>
            </>,
            document.body
        );
    };

    render() {
        const {
            color,
            isPreview,
            height,
            width
        } = this.props;

        const {
            isColorClicked,
            untouched
        } = this.state;

        return (
            <>
                {
                    isPreview ? /* to remove the plus sign(addColour.png), used by Finish.js */
                        <ColorCircle
                            color={color}
                            isPreview={isPreview}
                            width={width}
                            height={height}
                        />
                        :
                        <>
                            <ColorCircle
                                color={color}
                                ref={this.triggerRef}
                                onClick={this.handleClick}
                                isPreview={!untouched}
                                width={width}
                                height={height}
                            />

                            {isColorClicked && (
                                this.renderPickerPopup(color)
                            )}
                        </>
                }
            </>
        );
    } 
}

export default ColorPicker;
